import React, { useState } from 'react';

const Filters = ({ columns, onChange }) => {
  const [filters, setFilters] = useState([]); // Tableau de filtres

  // Ajouter un filtre vide
  const addFilter = () => {
    setFilters([...filters, { column: '', value: '' }]);
  };

  // Mettre à jour un filtre
  const updateFilter = (index, field, newValue) => {
    const newFilters = [...filters];
    newFilters[index][field] = newValue;
    setFilters(newFilters);
    onChange(newFilters); // Remonte les filtres au parent
  };

  // Supprimer un filtre
  const removeFilter = (index) => {
    const newFilters = filters.filter((_, i) => i !== index);
    setFilters(newFilters);
    onChange(newFilters); // Remonte les filtres au parent
  };

  return (
    <div className="card mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        <i className="fas fa-filter mr-2 text-primary"></i>
        Filtres
      </h3>
      
      <div className="space-y-3">
        {filters.map((filter, index) => (
          <div key={index} className="flex gap-3 items-end p-3 bg-gray-50 rounded-lg">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Colonne
              </label>
              <select
                value={filter.column}
                onChange={(e) => updateFilter(index, 'column', e.target.value)}
                className="form-input"
              >
                <option value="">Sélectionner une colonne</option>
                {columns.map((col) => (
                  <option key={col.value} value={col.value}>
                    {col.label}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Valeur
                {filter.column === 'siret' && (
                  <span className="text-xs text-gray-500 ml-2">
                    (Saisir plusieurs SIRETs séparés par des virgules)
                  </span>
                )}
              </label>
              <input
                type="text"
                placeholder={filter.column === 'siret' ? "Ex: 12345678901234, 98765432109876" : "Valeur"}
                value={filter.value}
                onChange={(e) => updateFilter(index, 'value', e.target.value)}
                className="form-input"
              />
            </div>
            
            <button 
              onClick={() => removeFilter(index)}
              className="btn-danger px-3 py-2"
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        ))}
      </div>
      
      <button 
        onClick={addFilter}
        className="btn-secondary mt-4"
      >
        <i className="fas fa-plus mr-2"></i>
        Ajouter un filtre
      </button>
    </div>
  );
};

export default Filters;
